import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DateStyled, StyledText, StyledTitle } from './styles/DateStyled';

class Date extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      position: 0,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { datePosition } = nextProps;

    nextProps.getDateHeight(this.dateRef.offsetHeight);

    if (this.state.position !== datePosition) {
      this.setState({ position: datePosition });
    }
  }

  prepareDayMonth = () => {
    const { month } = this.props;
    return month.split(', ');
  };

  assignDateRef = (ref) => {
    this.dateRef = ref;
  };

  render() {
    const { day, offsetTop } = this.props;

    return (
      <DateStyled ref={this.assignDateRef} data-day={day} data-name="date" offsetTop={offsetTop}>
        <StyledTitle font="gotham" color="white">
          {day}
        </StyledTitle>
        <StyledText color="white" size="fs_m">
          {`${this.prepareDayMonth()[0]}${this.prepareDayMonth()[1] ? ', ' : ''}`}
        </StyledText>
        {this.prepareDayMonth()[1] && (
          <StyledText color="white" size="fs_m">
            {this.prepareDayMonth()[1]}
          </StyledText>
        )}
      </DateStyled>
    );
  }
}

Date.propTypes = {
  day: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
  offsetTop: PropTypes.number.isRequired,
  datePosition: PropTypes.number,
  getDateHeight: PropTypes.func,
};

Date.defaultProps = {
  datePosition: 0,
  getDateHeight: Function.prototype,
};

export default Date;
